export default __webpack_public_path__ + "static/media/11-abstract_thumb.0b11fd51.jpg";